
import styled from "styled-components";
import theme from "./../../styles/theme"

export const Header = styled.header`
  background-color: #000;
  height: 96px;
  padding: 20px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 12;

  .hs-image {
    width: auto;
  }

  .header__images {
    height: 100%;
    gap: 40px;
    display: flex;
    justify-content: flex-start;

    img {
      max-width: 130px;
    }
  }


  @media (max-width:  ${theme.breakpoints.medium}){
    align-items: center;
    display: flex;
    gap: 15px;
    padding: 10px 0;

    div {
      width: 50%;
    }
  }

`;
export const ModalWrapper = styled.div`
`;

export const HeaderScrolly = styled.div`
  margin: 17px -20px;
  background: ${theme.colors.gray};
  padding: 20px 0;
  display: flex;
  justify-content: center;
  gap: 20px;

  @media (max-width:  ${theme.breakpoints.medium}) {
      display: none;
    }

`;

export const HeaderScrollyLink = styled.a`
  color: #fff !important;
  display: flex;
  font-family: 'Montserrat';
  font-size: ${theme.fontSizes.small};
  font-weight: 500;
  text-decoration: none;

  &:hover{
    cursor: pointer;

    &::before{
      content: '';
      position: absolute;
      background: url('https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/header/Polygon.svg');
      width: 8px;
      height: 16px;
    }
  }

`;

export const HeaderScrollyLinkText = styled.p`
  padding-left: 15px;
`;

export const Dropdonw = styled.div`
    position: absolute;
    top: 96px;
    right: 6%;
    width: 225px;
    padding: 30px 25px 30px 50px;
    display: flex;
    flex-direction: column;
    gap: 30px;
    align-items: flex-start;
    background: black;

    @media (max-width:  ${theme.breakpoints.medium}) {
      background-color: rgb(95, 95, 95);
      display: flex;
      gap: 0;
      left: 0;
      padding-bottom: 0;
      top: 96px;
      width: 225px;
    }
`;

export const ButtonCloseModal = styled.div`
  display: none;
  padding-left: 40px;

  @media (max-width:  ${theme.breakpoints.medium}) {
    display: flex;
  }
`;


export const LinksDropdonw = styled.a`
  color: white !important;
  font-family: ${theme.fonts.montSerrat};
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  text-align: initial;
  text-transform: uppercase;
  text-decoration: none;

  @media (max-width:  ${theme.breakpoints.medium}){
    padding-bottom: 22px;
  }

  &:hover{
    cursor: pointer;

    &::before{
      content: '';
      position: absolute;
      background: url('https://secure-static.arezzo.com.br/content/arz/sustainability-arezzo&co/imgs/header/Polygon.svg');
      width: 8px;
      height: 16px;
      left: 14%;
    }
  }
`;

export const KnowMore = styled.div`
  -webkit-appearance: none;
  display: none;
  padding: 10px 25px;
  width: 90px!important;

  div {
    width: 100%!important;
  }

  img{
    height: 100%;
    height: 100%!important;
  }

  @media (max-width:  ${theme.breakpoints.medium}){
    display: block;
  }

`;


